import dynamic from 'next/dynamic';

const SSRLeaflet = dynamic(() => import('./LeafletMap'), {
    ssr: false,
});

export default SSRLeaflet;
